(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    (function () {

    var btn = document.querySelector('.asyco-whatsapp-btn');

    if (!btn) return;

    var closeTimer = null;

    var isOpen = false;



    btn.addEventListener('touchstart', function (e) {

      if (!isOpen) {

        e.preventDefault();

        isOpen = true;

        btn.classList.add('is-open');

        clearTimeout(closeTimer);

        closeTimer = setTimeout(function () {

          isOpen = false;

          btn.classList.remove('is-open');

        }, 3000);

      }

    }, { passive: false });



    btn.addEventListener('mouseleave', function () {

      isOpen = false;

      btn.classList.remove('is-open');

      clearTimeout(closeTimer);

    });

  })();
  } catch(e) { console.error(e); }
})();

})();
